<template>
  <div class="content">
    <Form :model="formData" :label-width="150">
      <FormItem label="语音识别引擎">
        <Select v-model="formData.engine" style="width: 420px" :disabled="!isEdit" @on-change="engineChange">
          <Option value="">无</Option>
          <Option v-for="item in engines" :key="item.value" :value="item.value">{{ item.name }}</Option>
        </Select>
      </FormItem>
      <FormItem label="最大静音等待时长">
        <InputNumber :min="0" v-model="formData.max_silence" :disabled="!isEdit" style="width: 200px"></InputNumber><span style="margin-left: 5px">毫秒</span>
      </FormItem>
      <FormItem label="采集时最大静音时长">
        <InputNumber :min="0" v-model="formData.collect_silence" :disabled="!isEdit" style="width: 200px"></InputNumber><span style="margin-left: 5px">毫秒</span>
      </FormItem>
      <FormItem label="应用ID">
        <Input v-model="formData.app_id" :disabled="!isEdit" style="width: 420px"></Input>
      </FormItem>
      <FormItem label="参数">
        <div class="adv-params">
          <div
            v-for="(value, index) in formData.params"
            :key="index"
            class="adv-params__row"
          >
            <Input v-model="formData.params[index].key" :disabled="!isEdit" placeholder="参数名" />
            <Input v-model="formData.params[index].val" :disabled="!isEdit" />
            <Icon
              class="var-del-icon"
              color="#ed4014"
              type="ios-trash-outline"
              @click="formData.params.splice(index, 1)"
            />
          </div>
          <Button
            class="adv-params__add"
            type="dashed"
            long
            icon="md-add"
            :disabled="!isEdit"
            @click="addParameters"
          >添加参数</Button>
        </div>
      </FormItem>
      <FormItem>
        <Button type="primary" v-show="!isEdit" @click="openEdit">编辑</Button>
        <Button type="primary" v-show="isEdit" @click="save">保存</Button>
        <Button style="margin-left: 8px" v-show="isEdit" @click="cancel">取消</Button>
      </FormItem>
    </Form>
  </div>

</template>

<script>
import { mapState, mapActions } from 'vuex'
import { getSpeechRecognitionEngineA } from '@/server/api'

export default {
  data() {
    return {
      isEdit: false,
      formData: {
        engine: '',                 //ASR 引擎 目前仅支持 aliyun
        max_silence: 0,                    //ASR 默认最大静音等待时长
        collect_silence: 0,
        app_id: '',
        adv_params: {
          speech_noise_threshold: 0,
        },
        params: [{ key: '', type: 'NUM', val: '' }],
      },
      engines: [],
      createEngines: [],
      params: [],
    }
  },
	computed: {
    ...mapState('setting', ['asr']),
    ...mapState('user', [
     "company"
    ]),
	},
  watch: {
    asr: {
      immediate: true,
      handler(val) {
        this.resetForm()
      }
    }
  },
  methods: {
    ...mapActions('setting', ['updateAsr']),
    openEdit() {
      this.isEdit = true;
    },
    cancel() {
      this.isEdit = false;
      this.resetForm();
    },
    resetForm() {
      if (this.asr.engine && !['', 'aliyun', 'sensevoice'].includes(this.asr.engine)) {
        this.createEngines = [this.asr.engine];
      }
      let params = []
      if (this.asr && this.asr.adv_params) {
        params = Object.keys(this.asr.adv_params).map(key => {
          return {
            key,
            type: typeof this.asr.adv_params[key] === 'string' ? 'STR' : 'NUM',
            val: this.asr.adv_params[key]
          }
        })
      }
      this.formData = {
        ...this.formData,
        ...this.asr,
        params,
      }
    },
    save() {
      const { params, ...formData } = this.formData
      const parameters = params.filter(item => !!item.key && !!item.type).reduce((item, next) => {
        if (next.type === 'NUM') {
          item[next.key] = Number(next.val)
        } else {
          item[next.key] = next.val
        }
        return item
      }, {})
      this.updateAsr({
        ...formData,
        adv_params: parameters
      });
      this.isEdit = false;
    },
    // 获取语音识别引擎列表
    getSpeechRecognitionEngine() {
      getSpeechRecognitionEngineA().then(res => {
        if (res.code !== 200) return;
        this.engines = res.data?.filter(item => {
          if (['qwenasr'].includes(item.value) && ![974].includes(this.company.id)) return false;
          return true;
        }) || [];
      })
    },
    engineChange(value) {
      const engine = this.engines.find(item => item.value === value);
      if (!engine) return;
      this.formData.app_id = engine.code || this.formData.app_id;
    },
    // 添加参数
    addParameters() {
      this.formData.params.push({ key: '', type: 'STR', val: '' });
    },
  },
  created() {
    this.getSpeechRecognitionEngine();
  },
}
</script>

<style lang="scss" scoped>
.content {
  margin-top: 15px;
}

.adv-params {
  width: 400px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.adv-params__row {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;

  ::v-deep .ivu-input-wrapper {
    flex: 1;
    min-width: 0;
  }
}

.adv-params__add {
  width: 100%;
  margin-left: 0;
}

.var-del-icon {
  cursor: pointer;
  line-height: 32px;
}
</style>
